import React from 'react'
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({ 
    label: {
        fontSize: '12px', 
        margin: 0,
        lign:'left', 
        lineHeight: '14px', 
        fontWeight: 'bold'
      },
      deleteIcon:{
        marginTop:'50%'
      },
      docTextField: {
        marginTop: '5px',
        marginBottom: '5px',
        fontStyle: 'italic',
        lineHeight: '2',
        width:'100%'
      },
      button: {
        display: 'inline-block',
        marginLeft:'10px',
        marginBottom:'20px',
        fontSize:'10px'
      },
      addRowButton: {
        display: 'inline-block',
        marginBottom:'20px',
        fontSize:'10px'
      }
})

const Item = (props) =>{

    const classes = useStyles();

    function handleSingleCLick(click){
        click.stopPropagation();
    }

    function renderColumns(columns){
    var array = []
    for(let i=0;i<columns;i++){
        array.push(
            <td>
                <input  value={""} className={classes.docTextField} onClick={click=>handleSingleCLick(click)} type="text"  name="123" />
            </td>)
    }
    return array;
        
}
function renderTextFields(rows,columns){
    var arr =[];
    for (let i=0;i<rows;i++){
        arr.push(
            <tr>
                {renderColumns(columns)}
            </tr>
        )
    }
    return arr;
}

function labelContainer(name,index){
    if(false || props.type === "preview" ){
        return (
            <p key={1} disabled={true} className={classes.label}>{name}</p>
        )
    }
    else {
        return (
            <input key={1} onClick={click=>props.handleSingleClick(click,props.row,props.col,index)} onChange={e=>props.handleChange(e.target.value,props.row,props.col,index)} className={classes.label} placeholder='Enter Label' value={name} autoFocus={''+props.row+props.col+index==props.focus?true:false}/>
        )
    }
}
    
    return(

        <table style={{width:'100%',textAlign:'center'}}>
            <tbody>
                <tr>
                    {props.labels.map((name,index) => (
                        <td>
                            {labelContainer(name,index)}
                        </td>
                    ))}
                </tr>
                
                {renderTextFields(props.textFields.rows,props.textFields.columns)}
                
                
            </tbody>
        </table>
    )
}

export default Item